import { apiFetch } from './client';

export function listCohortInvites() {
  return apiFetch('/cohort/invites');
}

export function createCohortInvite(tutorUserId = null) {
  const payload = tutorUserId ? { tutor_user_id: Number(tutorUserId) } : {};
  return apiFetch('/cohort/invites', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export function revokeCohortInvite(inviteId) {
  return apiFetch(`/cohort/invites/${inviteId}/revoke`, { method: 'POST' });
}

export function listCohortRequests() {
  return apiFetch('/cohort/requests');
}

export function listCohortStudentCandidates(requestId) {
  return apiFetch(`/cohort/requests/${requestId}/student-candidates`);
}

export function matchCohortRequest(requestId, studentUserId) {
  return apiFetch(`/cohort/requests/${requestId}/match`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ student_user_id: Number(studentUserId) }),
  });
}

export function rejectCohortRequest(requestId) {
  return apiFetch(`/cohort/requests/${requestId}/reject`, { method: 'POST' });
}
